import { getFormFieldDescriptors, SALESFORCE_API } from './constants';
import {ContactUsFormValues} from "../../common/models/common.models";

type FormFieldDescriptor = {
    name: string;
    value: string;
    id?: string;
}

const createFormField = ({ name, value, id }: FormFieldDescriptor) => {
    const element = document.createElement('input');
    element.name = name;
    element.value = value;
    element.setAttribute('type', 'hidden');
    if (id) {
        element.id = id;
    }
    return element;
};

const createForm = (apiEndpoint: string, formName: string, formData: ContactUsFormValues) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = apiEndpoint;

    for (const formField of getFormFieldDescriptors(formName, formData)) {
        form.appendChild(createFormField(formField as FormFieldDescriptor));
    }
    return form;
};

export const sendSalesforceLead = (formName: string, data: ContactUsFormValues) => {
    const leadForm = createForm(SALESFORCE_API, formName, data);
    const iframe = document.createElement('iframe');
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    document.body.appendChild(iframe);
    iframe.contentWindow?.document.body.appendChild(leadForm);
    leadForm.submit();

    setTimeout(function () {
        iframe.parentNode?.removeChild(iframe);
    }, 3000);
};
